// extracted by mini-css-extract-plugin
export default {"link":"breadcrumb_link__vvwc8"};